<template>
  <div class="rules-container" v-if="orderobj">
    <Modal
      title
      v-model="showRefoundExchangeInfo_new"
      @on-cancel="close"
      width="800"
      class-name="vertical-center-modal rules-modal"
    >
      <div class="header">
        换货信息
        <Icon @click="close" type="md-close" />
      </div>
      <div class="package-info">
        <div class="package-list">
          <div
            @click="changePackage(index,item)"
            :class="['package',refoundIndex== index ? 'active':'']"
            v-for="(item,index) in refundList_new"
            v-if="refundList_new.length>1"
            :key="index"
          >
            换货单
            <span>{{index+1}}</span>
          </div>
        </div>
        <div class="content">
          <div v-if="orderobj.status ==102">
            <div class="status">
              <img class="status-icon" src="../../assets/image/icon/tip-info.svg" />
               换货中
            </div>
            <div class="text">您的换货正在处理中，请耐心等待</div>
          </div>
          <div v-else-if="orderobj.status ==103">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/success-info.svg" />
                已换货
              </div>

            </div>
             <div class="text">商家已在{{orderobj.exchangeSendDate}}完成换货 
               <!-- <div class="text getwuliu" @click="getWuliudetail">查看物流</div> --> 
            </div>
           
          </div>
          <div v-else-if="orderobj.status ==104">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/error-info.svg" />
                撤销换货
              </div>
            </div>
            <div class="text">您的换货已撤销，如有问题请联系我们</div>
          </div>
          <!-- <div v-else-if="orderobj.status == 4">
            <div class="status">
              <div>
                <img class="status-icon" src="../../assets/image/icon/error-info.svg" />退款失败
              </div>
            </div>
            <div class="text">请联系客服查询退款失败原因</div>
          </div> -->
        </div>
      </div>
      <!-- 物流start -->
      <div class="content_wuliu">
          <div class="content-info">
            <div class="company">
              <div class="item">
                <div>物流公司：</div>
                <div>{{orderobj.exchangeExpressCompany}}</div>
              </div>
              <div class="item">
                <div>物流单号：{{orderobj.exchangeExpressNo}}</div>
                <div>
                  <span class="copy" @click="copy()">复制</span>
                </div>
              </div>
            </div>
            <div>
              <div v-if="currentWuliuInfo.length>0">
                <div v-for="(item,index) in currentWuliuInfo" :key="index">
                  <div style="margin-bottom:5px">{{item.datetime}}</div>
                  <div>{{item.remark}}</div>
                </div>
              </div>
              <div v-else>暂未查到物流信息</div> 
              <!-- 我是包裹
              <span>{{deliveryIndex}}</span>
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员
              区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员区速递易【自提柜】代收，请及时取件。有问题请联系派件员-->
            </div>
          </div>
        </div>

      <!-- 物流end -->
      <div class="good-list">
        <div class="good-label">原商品</div>
        <div class="cart-item" v-for="(item,index) in orderobj.list" :key="index">
          <div class="cart-left">
            <div class="cart-img">
              <img :src="item.url" />
            </div>

            <div class="cart-info">
              <div class="cart-info-detail">
                <div class="good-name">
                  <span>{{item.name}}</span>
                </div>
                <div class="good-size">
                  尺码.
                  <span
                    class="value"
                    v-for="(v, i) in item.specType"
                    :key="i"
                  >{{v}}{{i!=item.specType.length-1?'；':''}}</span>
                </div>
                <div class="good-color">
                  颜色.
                  <span class="value">{{item.colorText}}</span>
                </div>
                <div class="good-num">
                  数量.
                  <span class="value">{{item.refundNum}}</span>
                </div>
              </div>
             <div class="cart-price">
                  <template v-if="item.discountPrice!='0'&&item.discountPrice!=undefined">
                    <div
                      class="originprice"
                      style="margin-bottom:1.5rem"
                    >¥{{$utils.toThousands(item.price) }}</div>
                    <div class="currprice">¥{{$utils.toThousands(item.discountPrice)}}</div>
                  </template>
                  <template v-else>
                    <div class="currprice">¥{{$utils.toThousands(item.price)}}</div>
                  </template>
                </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 换成商品start -->
        <div class="good-list good-list2">
        <div class="good-label">换成商品</div>
        <div class="cart-item" v-for="(item,index) in orderobj.orderSkuItemExchangeList" :key="index">
          <div class="cart-left">
            <div class="cart-img">
              <img :src="item.productImage" />
            </div>

            <div class="cart-info">
              <div class="cart-info-detail">
                <div class="good-name">
                  <span>{{item.productName}}</span>
                </div>
                <div class="good-size">
                  尺码.
                  <span
                    class="value"
                    v-for="(v, i) in item.specType"
                    :key="i"
                  >{{v}}{{i!=item.specType.length-1?'；':''}}</span>
                </div>
                <div class="good-color">
                  颜色.
                  <span class="value">{{item.colorText}}</span>
                </div>
                <div class="good-num">
                  数量.
                  <span class="value">{{item.productQuantity}}</span>
                </div>
              </div>
                <div class="cart-price">
                  <template v-if="item.productDiscountPrice!='0'&&item.productDiscountPrice!=undefined">
                    <div
                      class="originprice"
                      style="margin-bottom:1.5rem"
                    >¥{{$utils.toThousands(item.productPrice) }}</div>
                    <div class="currprice">¥{{$utils.toThousands(item.productDiscountPrice)}}</div>
                  </template>
                  <template v-else>
                    <div class="currprice">¥{{$utils.toThousands(item.productPrice)}}</div>
                  </template>
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 换成商品end -->
      <div class="refound-info">
        <div class="item">
          <div class="label">售后类型</div>
          <div class="value">
            <span>换货</span>
          </div>
        </div>
        <div class="item">
          <div class="label">售后单号</div>
          <div class="value">{{orderobj.refundNo}}</div>
        </div>
        <div class="item">
          <div class="label">申请时间</div>
          <div class="value">{{orderobj.applyDate}}</div>
        </div>
        <div class="item" v-if="orderobj.exchangeSendDate">
          <div class="label">发货时间</div>
          <div class="value">{{orderobj.exchangeSendDate}}</div>
        </div>
        <div class="item" v-if="orderobj.exchangeCancelDate">
          <div class="label">撤销时间</div>
          <div class="value">{{orderobj.exchangeCancelDate}}</div>
        </div>
      </div>
    </Modal>
    <!-- <delivery-exchange @closeDelivery="closeDelivery" :orderInfo="orderobj" :showDeliverInfo="showDeliverInfo"></delivery-exchange> -->
  </div>
</template>

<script>
import DeliveryExchange from "./DeliveryExchange.vue"
export default {
  name: "DeliveryRules",
  data() {
    return {
      status: 1,
      refoundIndex: 0,
      API: this.$store.state.API,
      refundList_new: [],
      orderobj: null,
      refunddate: "",
      type: "",
      showDeliverInfo:false,
      currentWuliuInfo:[],
      showRefoundExchangeInfo_new:false
    };
  },
  props: {
    showRefoundExchangeInfo: {
      type:Boolean,
      default: false
    },
    exchangeList: {
      type: Array,
      default: []
    }
  },
  watch: {
    exchangeList: {
      immediate: true,
      handler(curVal, oldVal) {
        this.refundList_new = curVal;
        this.getRefundDetail(curVal[0]);
      },
      deep: true //true 深度监听
    },
    showRefoundExchangeInfo:{
      handler(curVal, oldVal) {
        if(curVal){
          this.getRefundDetail(this.refundList_new[0]);
        }
        this.showRefoundExchangeInfo_new=curVal;
      }
    }
  },
  components: {DeliveryExchange},
  methods: {
    changePackage(index, id) {
      this.refoundIndex = index;
      this.getRefundDetail(id);
    },
    async getRefundDetail(id) {
      let url = this.API.order.refundDetail;
      let OpenId = await this.$utils.CheckOpenIdExist(this);
      let params = {
        orderSkuItemRefundId: id,
        openId: OpenId || this.$store.state.userId
      };
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            this.orderobj = res.data.returnData.refundOrderItemListVo;
            this.orderobj.orderSkuItemRefundId=id;
            this.refunddate =res.data.returnData.refundOrderItemListVo.successDate;
            this.type = res.data.returnData.type;
            this.getWuliu();
          
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(err => {});
    },
     getWuliu() {
      let url = this.API.order.queryLogistics;
      let params = {
        merchantId: this.$store.state.storeId,
        orderId:this.orderobj.orderId,
        shipmentNo:this.orderobj.exchangeExpressNo,
        orderSkuItemRefundId:this.orderobj.orderSkuItemRefundId
      };
      // this.currentSkuInfo = e;
      this.$http
        .post(url, this.$qs.stringify(params))
        .then(res => {
          if (res.data.result) {
            // this.currentSkuInfo = e;
            // console.log(this.currentSkuInfo, "currentSkuInfo");
            this.currentWuliuInfo = res.data.returnData.details || [];
          } else {
            this.currentWuliuInfo = [];
          }
        })
        .catch(err => {
          console.log(err,'失败了吗')
        });
    },
    copy() {
      var copyTest = this.orderobj.exchangeExpressNo;
      var inputTest = document.createElement("input");
      inputTest.value = copyTest;
      document.body.appendChild(inputTest);
      inputTest.select();
      document.execCommand("Copy");
      inputTest.className = "oInput";
      inputTest.style.display = "none";
      this.$Message.success("复制成功");
    },
    goRouter(_r) {
      this.$router.push({ path: _r });
    },
    getWuliudetail(){
       this.showDeliverInfo=true;
    },
    close() {
      this.refoundIndex=0;
      this.$emit("close");
    },
    closeDelivery(){
      this.showDeliverInfo=false;
    }
  }
};
</script>
<style lang="less" scoped>
.part-container {
  padding-top: 3rem;
}

/deep/.rules-modal .ivu-modal-content {
  min-height: 40rem;
  padding: 2rem 2rem;
  margin: auto;
  display: flex;
  justify-content: space-around;
  color: #5c5d5f;
  background-color: #fff;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  .header {
    margin-bottom: 1.5rem;
    text-align: left;
    i {
      float: right;
      font-size: 1.6rem;
      color: #000000;
      margin-top: -0.4rem;
      margin-right: -0.4rem;
      cursor: pointer;
      font-weight: 500;
      // margin-top: -1px;
    }
  }
  .package-info {
    margin-bottom: 2rem;
    .package-list {
      display: flex;
      flex-direction: row;
      .package {
        cursor: pointer;
        padding: 2rem 4rem 2rem 0;
        color: #959595;
        &.active {
          color: #5c5d5f;
        }
        span {
          padding: 0 0.3rem;
        }
      }
    }

    .content {
      border: 0.1rem solid #eaeaea;
      padding: 2rem;
      text-align:left;
      .status {
        padding-bottom: 0.8rem;
        .status-icon {
          width: 1.4rem;
          height: 1.4rem;
        }
      }
    }
  }
  .good-list {
    border: 0.1rem solid #eaeaea;
    padding-top: 2rem;
    &.good-list2{
      margin-top:2.4rem;
    }
    .cart-item {
      // border: 0.1rem solid #eaeaea;
      // padding-top: 2rem;
    }
  }
  .content_wuliu {
      border: 0.1rem solid #eaeaea;
      padding: 2rem;
      line-height: 1.7rem;
      margin-bottom:2.4rem;
      .content-info {
        max-height:11rem;
        overflow: auto;
        text-align: left;

        .company {
          padding-bottom: 2rem;
        }
        .company .item {
          display: flex;
          .copy {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  .refound-info {
    border: 0.1rem solid #eaeaea;
    padding: 2rem;
    margin-top: 2rem;
    .item {
      display: flex;
      justify-content: space-between;
      line-height: 2rem;
    }
  }
}
/deep/.rules-modal .ivu-modal-body {
  padding: 0;
  line-height: 1.2;
  font-size: 1.2rem;
  width: 100%;
}

/deep/.ivu-modal {
  margin: 10px 0;
  margin-top:260px;
}
@media screen and (max-width: 1024px) {
  /deep/.rules-modal .ivu-modal-content {
    width: calc(100% - 4rem);
    min-height: 15rem;
  }
}
@media screen and (max-width: 768px) {
  /deep/ .rules-modal .ivu-modal-content {
    width: 100%;
    padding: 2rem;
  }
  /deep/ .ivu-modal{
    margin-top:240px;
  }
}

.good-label{
  text-align: left;
  margin-left: 2rem;
  margin-bottom: 2rem;
}
.getwuliu{
  float: right;
  text-decoration: underline;
  cursor: pointer;
}
 .good-list .cart-item .cart-left .cart-info{
    .good-name{
      justify-content:start
    }
    .originprice{
      margin-right:1.5rem
    }
    .originprice,.currprice{
      display:inline-block;
    }
   }
</style>


// WEBPACK FOOTER //
// src/components/common/RefundExchangePop.vue